import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, skipTermsCheck = false }) => {
    const { isAuthenticated, loading } = useAuth();
    useLocation(); // Keep for potential future use

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            }}>
                <div style={{
                    textAlign: 'center',
                    color: 'white',
                }}>
                    <div style={{
                        width: '50px',
                        height: '50px',
                        border: '4px solid rgba(255, 255, 255, 0.3)',
                        borderTop: '4px solid white',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        margin: '0 auto 20px',
                    }}></div>
                    <p>Loading...</p>
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    // Check if user has accepted terms of service (unless skipTermsCheck is true)
    // TEMPORARILY DISABLED - uncomment to re-enable terms of service requirement
    // if (!skipTermsCheck && user && !user.accepted_terms_of_service) {
    //     // Don't redirect if already on the TOS page
    //     if (location.pathname !== '/terms-of-service') {
    //         return <Navigate to="/terms-of-service" replace />;
    //     }
    // }

    return children;
};

export default ProtectedRoute;

